import React, { useState, useEffect, useCallback } from "react"
import { useParams, useSearchParams } from "react-router-dom"
import { queryTools, ELEMENTS } from "lib/utils"
import { useAppCtx, appStore } from "lib/state"
import { Presets } from "lib/units/template/build"

import { default as DetailScreensEditingArea } from 'lib/units/element/DetailScreens/DetailScreensEditingArea';
import { default as SupportingImagesEditingArea } from 'lib/units/element/SupportingImages/SupportingImagesEditingArea';
import { default as StatementEditingArea } from 'lib/units/element/Statement/StatementEditingArea';
import { default as SummaryBlockEditor } from 'lib/units/element/SummaryBlock/SummaryBlockEditor';
import { default as SummaryTableEditingArea } from 'lib/units/element/SummaryTable/SummaryTableEditingArea';
import { default as PoliciesEditingArea } from 'lib/units/element/Policies/PoliciesEditingArea';
import { default as TitleBlockEditor } from 'lib/units/element/TitleBlock/TitleBlockEditor';
import { default as TrxHistoryTableEditingArea } from 'lib/units/element/TrxHistoryTable/TrxHistoryTableEditingArea';

const testPresets = [
  { _id: "7ghudwdgwdgcwec", subdomain: "woopla", rpid: "257" },
  { _id: "yfvwhc8weyc7wdw", subdomain: "lifetimewell", rpid: "109" },
  { _id: "7ghuwgcuwegcuee", subdomain: "sohoecomm", rpid: "226" },
  { _id: "323defher8hvrer", subdomain: "alpineadministrativegroup", rpid: "35" },
  { _id: "sdc893tf3td374f", subdomain: "thevariantgroup", rpid: "3307" },
]

export default function MainBuildArea(){
  
  const { tmplid } = useParams()
  const [ searchParams, setSearchParams ] = useSearchParams();

  const { appState }:any = useAppCtx()
  const { store, AppStore }:any = appStore()

  const { get, update } = AppStore

  const { data:_Template } = queryTools.resource.parseQueryForApi("template.findById", { _id: tmplid })

  const editingAreas = {
    "compelling_evidence": <StatementEditingArea type="compelling_evidence" />,
    "opening_statements": <StatementEditingArea type="opening_statements" />,
    "summary_block": <SummaryBlockEditor />,
    "summary_table": <SummaryTableEditingArea />,
    "supporting_images": <SupportingImagesEditingArea />,
    "title_block": <TitleBlockEditor />,
    "detail_screens": <DetailScreensEditingArea />,
    "policies": <PoliciesEditingArea />,
    "trx_history": <TrxHistoryTableEditingArea />
  }

  const loadElementEditor = () => {
    const { elem, refstr } = Object.fromEntries(searchParams)
    const currElement = ELEMENTS.find( (elemObj:any) => elemObj.refstr === elem )
    const config = _Template?.Elements.find( (item:any) => item.refstr === elem ).config
    if(currElement){
      update("location", {...store.location, element: elem})
      update("element", {...currElement, config})
    }
  }
  useEffect(() => {
    loadElementEditor()
  },[searchParams])

  if( !_Template ) return <></>
  return (
    <div className="w-full flex flex-col relative">
      {/* <Presets location="build" /> */}

      { searchParams.get("elem") !== null && store.element?.refstr !== null && (
        <div className="w-full h-full flex flex-col mt-2 gap-4">
          { editingAreas[searchParams.get("elem") as keyof typeof editingAreas] }
        </div>
      )}

    </div>
  )
}
